
    // @ts-nocheck
    // This file is auto generated
    export const iconNames = [
  {
    "name": "asterisk",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  },
  {
    "name": "avatar-circle",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  },
  {
    "name": "bell",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {
      "nav-notification": {
        "weight": "bold"
      }
    }
  },
  {
    "name": "checkmark",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-down",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-left",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-right",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "chevron-up",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "cog",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "cross",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "ellipsis",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "eye-striked",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  },
  {
    "name": "file-pdf",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  },
  {
    "name": "list",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "live-indicator",
    "outlineWeights": [
      "normal"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "minus",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "notification-error",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-information",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-information": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "notification-warning",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "notification-warning": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "octagon-lightning",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "error": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "pencil-square",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "plus",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "question-mark",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "sort",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "square-info",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {
      "info": {
        "weight": "bold",
        "filled": true
      }
    }
  },
  {
    "name": "tiles",
    "outlineWeights": [
      "bold"
    ],
    "filledWeights": [],
    "legacyNames": {}
  },
  {
    "name": "triangle-warning",
    "outlineWeights": [],
    "filledWeights": [
      "bold"
    ],
    "legacyNames": {}
  }
]
    